(function () {
  const parseI18n = (root) => {
    const node = root.querySelector('[data-product-questions-i18n]');
    if (!node) {
      return {};
    }
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return {};
    }
  };

  const getQuestionDate = (item) => {
    return item.questionDate || item.createdAt || '';
  };

  const getQuestionDateLabel = (item) => {
    if (item.displayDate) {
      return item.displayDate;
    }
    const iso = getQuestionDate(item);
    if (!iso) {
      return '';
    }
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) {
      return '';
    }
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  };

  const decodeEntities = (value) => {
    return String(value || '')
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"');
  };

  const buildQuestionCountLabel = (count, template) => {
    if (!template) {
      return String(count);
    }
    return decodeEntities(template.replace(/\{\{\s*count\s*\}\}/g, String(count)));
  };

  const updateQaTabLabel = (tabsRoot, count, baseLabel) => {
    if (!tabsRoot || !baseLabel) {
      return;
    }
    const tab = tabsRoot.querySelector('[data-product-tab="qa"]');
    if (!tab) {
      return;
    }
    if (count > 0) {
      tab.textContent = `${baseLabel} (${count})`;
    } else {
      tab.textContent = baseLabel;
    }
  };

  const sortQuestions = (items, mode) => {
    const list = items.slice();
    list.sort((a, b) => {
      const timeA = new Date(getQuestionDate(a)).getTime();
      const timeB = new Date(getQuestionDate(b)).getTime();
      if (mode === 'oldest') {
        return timeA - timeB;
      }
      return timeB - timeA;
    });
    return list;
  };

  const filterQuestions = (items, query) => {
    const term = String(query || '').trim().toLowerCase();
    if (!term) {
      return items;
    }
    return items.filter((item) => {
      const body = String(item.body || '').toLowerCase();
      const answer = String(item.answer || '').toLowerCase();
      return body.includes(term) || answer.includes(term);
    });
  };

  const createCard = (item, i18n) => {
    const card = document.createElement('article');
    card.className = 'product-questions__card';

    const question = document.createElement('div');
    question.className = 'product-questions__question';

    const body = document.createElement('p');
    body.className = 'product-questions__question-body';
    body.textContent = item.body || '';
    question.appendChild(body);

    const foot = document.createElement('div');
    foot.className = 'product-questions__question-foot';

    const meta = document.createElement('div');
    meta.className = 'product-questions__question-meta';

    const name = document.createElement('span');
    name.className = 'product-questions__question-name';
    name.textContent = item.displayName || i18n.guestName || '';

    const divider = document.createElement('span');
    divider.className = 'product-questions__question-divider';
    divider.setAttribute('aria-hidden', 'true');
    divider.textContent = '•';

    const date = document.createElement('time');
    date.className = 'product-questions__question-date';
    date.dateTime = getQuestionDate(item);
    date.textContent = getQuestionDateLabel(item);

    meta.appendChild(name);
    meta.appendChild(divider);
    meta.appendChild(date);
    foot.appendChild(meta);

    question.appendChild(foot);
    card.appendChild(question);

    if (item.answer) {
      const answerBox = document.createElement('div');
      answerBox.className = 'product-questions__answer';

      const badge = document.createElement('span');
      badge.className = 'product-questions__answer-badge';
      badge.textContent = decodeEntities(i18n.answeredLabel || '');
      answerBox.appendChild(badge);

      const answerText = document.createElement('p');
      answerText.className = 'product-questions__answer-body';
      answerText.textContent = item.answer;
      answerBox.appendChild(answerText);

      card.appendChild(answerBox);
    }

    return card;
  };

  const initQuestionsRoot = (root) => {
    if (root.dataset.productQuestionsInitialized === 'true') {
      return;
    }

    const apiBase = root.dataset.productQuestionsApi || 'https://joker-baby-shopify-app.vercel.app';
    const shop =
      typeof window.jokerStorefrontShop === 'function'
        ? window.jokerStorefrontShop(root.dataset.productQuestionsShop)
        : String(root.dataset.productQuestionsShop || '').trim().toLowerCase();
    const productId = root.dataset.productQuestionsProductId || '';
    const limit = Math.min(50, Math.max(4, Number(root.dataset.productQuestionsLimit) || 20));
    const i18n = parseI18n(root);

    const loadingEl = root.querySelector('[data-product-questions-loading]');
    const errorEl = root.querySelector('[data-product-questions-error]');
    const emptyEl = root.querySelector('[data-product-questions-empty]');
    const filledEl = root.querySelector('[data-product-questions-filled]');
    const listEl = root.querySelector('[data-product-questions-list]');
    const noResultsEl = root.querySelector('[data-product-questions-no-results]');
    const summaryCountEl = root.querySelector('[data-product-questions-summary-count]');
    const searchInput = root.querySelector('[data-product-questions-search]');
    const sortSelect = root.querySelector('[data-product-questions-sort]');

    const tabsRoot = root.closest('[data-product-tabs]');
    const qaTab = tabsRoot ? tabsRoot.querySelector('[data-product-tab="qa"]') : null;
    const qaTabBaseLabel = qaTab ? qaTab.dataset.productTabQaLabel || qaTab.textContent.trim() : '';

    if (!listEl || !apiBase || !shop || !productId) {
      return;
    }

    let allQuestions = [];
    let loadStarted = false;

    const setVisible = (node, visible) => {
      if (!node) {
        return;
      }
      if (visible) {
        node.removeAttribute('hidden');
      } else {
        node.setAttribute('hidden', '');
      }
    };

    const showLoading = () => {
      setVisible(loadingEl, true);
      setVisible(errorEl, false);
      setVisible(emptyEl, false);
      setVisible(filledEl, false);
    };

    const showError = (message) => {
      setVisible(loadingEl, false);
      setVisible(emptyEl, false);
      setVisible(filledEl, false);
      if (errorEl) {
        errorEl.textContent = message || '';
      }
      setVisible(errorEl, true);
    };

    const showEmptyState = () => {
      setVisible(loadingEl, false);
      setVisible(errorEl, false);
      setVisible(filledEl, false);
      setVisible(emptyEl, true);
      updateQaTabLabel(tabsRoot, 0, qaTabBaseLabel);
    };

    const renderList = () => {
      const sortMode = sortSelect ? sortSelect.value : 'newest';
      const searchTerm = searchInput ? searchInput.value : '';
      const filtered = filterQuestions(allQuestions, searchTerm);
      const sorted = sortQuestions(filtered, sortMode);

      if (summaryCountEl) {
        summaryCountEl.textContent = buildQuestionCountLabel(allQuestions.length, i18n.questionCount);
      }
      updateQaTabLabel(tabsRoot, allQuestions.length, qaTabBaseLabel);

      listEl.innerHTML = '';

      if (sorted.length === 0) {
        setVisible(noResultsEl, true);
        return;
      }

      setVisible(noResultsEl, false);
      sorted.forEach((item) => {
        listEl.appendChild(createCard(item, i18n));
      });
    };

    const showFilledState = () => {
      setVisible(loadingEl, false);
      setVisible(errorEl, false);
      setVisible(emptyEl, false);
      setVisible(filledEl, true);
      renderList();
    };

    const loadQuestions = async () => {
      if (loadStarted) {
        return;
      }
      loadStarted = true;
      showLoading();

      const url = `${apiBase.replace(/\/$/, '')}/api/storefront/questions?shop=${encodeURIComponent(shop)}&productId=${encodeURIComponent(productId)}&limit=${encodeURIComponent(String(limit))}`;

      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error('fetch failed');
        }
        const payload = await response.json();
        allQuestions = Array.isArray(payload.questions) ? payload.questions : [];
        if (allQuestions.length === 0) {
          showEmptyState();
        } else {
          showFilledState();
        }
      } catch (error) {
        showError(i18n.loadError || '');
      }
    };

    if (searchInput) {
      searchInput.addEventListener('input', () => {
        renderList();
      });
    }

    if (sortSelect) {
      sortSelect.addEventListener('change', () => {
        renderList();
      });
    }

    loadQuestions();
    root.dataset.productQuestionsInitialized = 'true';
  };

  const init = (scope) => {
    scope.querySelectorAll('[data-product-questions]').forEach(initQuestionsRoot);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
